import React from "react";
import { PreviewLocationBlockProps } from "./types";
import { IconList } from "../IconList";
import { Icons } from "@/types/icons";
import { checkValidURL } from "@/utils/formHelper";

//TODO: add classNames to props to make component ui-headless
export const PreviewLocationBlock = ({ data, title }: PreviewLocationBlockProps) => {
  const { address, numeration, city, zipCode, state, country, fullAddress } = data || {};

  if (!data || (!address && !numeration && !city && !zipCode && !state && !country)) {
    return null;
  }

  const addressMapsURL = `http://maps.google.com/?q=${fullAddress}`;

  return (
    <div className="u-card business-location">
      <IconList
        iconItem
        items={{
          icon: Icons.location,
          title,
        }}
        tag={"h6"}
        semibold
      />
      <a
        className="business-link"
        href={checkValidURL(addressMapsURL)}
        target="_blank"
        rel="noreferrer">
        {fullAddress}
      </a>
    </div>
  );
};
